import { render, staticRenderFns } from "./TraceResume.vue?vue&type=template&id=9e1f65a2&scoped=true&"
import script from "./TraceResume.vue?vue&type=script&lang=js&"
export * from "./TraceResume.vue?vue&type=script&lang=js&"
import style0 from "./TraceResume.vue?vue&type=style&index=0&id=9e1f65a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1f65a2",
  null
  
)

export default component.exports